module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar c, cd, category, categoryData, aT, categoryAdditionalClasses, categoryDataAdditionalClasses, assignedTagAttributes, selected, dirty, showOption, dirtyTag, dirtyTagID;\nvar turnedOff, turnedOn, turnedOffByInheritance;\nvar preparedAssignedTag;\nvar level, lastLevel, l;\nvar showTagNumbers = storage.user.hasAccessTo('usage:show_lse_tag_numbers', 'literature');\nvar additionalClasses = [];\nif(resourceData.useNormalDirtyColor){\nadditionalClasses.push('dirtyColorNormal');\n}\nif(config.isEnhanced !== false){\nadditionalClasses.push('isEnhanced');\n} else {\nadditionalClasses.push('isNotEnhanced');\n}\n%>\n<div class=\"<%= additionalClasses.join(' ') %>\">\n<%\nif(config.isEnhanced !== false){\n%><%- helpers.renderSection('enhanced'); %><%\n}\n%>\n<section class=\"tagsOnly\">\n<%- helpers.renderSection('filter'); %>\n<section class=\"content\">\n<%\nfor(c in resourceData.options || []) {\ncategory = resourceData.options[c];\ncategoryAdditionalClasses = [];\nif(resourceData.preparedAssignedCategories[category.id]){\npreparedAssignedTag = resourceData.preparedAssignedCategories[category.id];\nturnedOff = preparedAssignedTag.turnedOff;\nturnedOn = preparedAssignedTag.turnedOn;\nturnedOffByInheritance = preparedAssignedTag.turnedOffByInheritance;\n} else {\npreparedAssignedTag = { noData: true };\nturnedOff = false;\nturnedOn = false;\nturnedOffByInheritance = (resourceData.inheritedCategories || {})[category.id] === false;\n}\ndirty = false;\nselected = !turnedOff && (!turnedOffByInheritance || turnedOn);\ninherited = !turnedOff && !turnedOn;\nshowOption = resourceData.optionalCategories && model.turnedOffTagCategoryManagementGranted;\n// check if categoryData is selected by dirty resources\nif((dirtyTag = model.dirtyAssignedTags[category.id + '_null'])){\ndirty = true;\nselected = !selected;\n}\nif(selected) \tcategoryAdditionalClasses.push('selected');\nif(dirty) \t\tcategoryAdditionalClasses.push('dirty');\nif(showOption) \tcategoryAdditionalClasses.push('showOption');\nif(inherited) \tcategoryAdditionalClasses.push('inherited');\nif((!turnedOff && !turnedOffByInheritance) || model.turnedOffTagCategoryManagementGranted){\n%>\n<div class=\"category <%= categoryAdditionalClasses.join(' ') %>\" data-category-id=\"<%- category.id %>\" data-category-data-id=\"null\">\n<i class=\"unselected fi fi-tagFamily-unselected\"></i>\n<i class=\"selected fi fi-tagFamily-selected\"></i>\n<i class=\"inherited fi fi-tagFamily-inherited\"></i>\n<%= category.name %><%= (showTagNumbers ? ' [' + category.id + ']' : '') %>\n</div>\n<%\nlastLevel = undefined;\nfor(cd in category.children || []) {\ncategoryData = category.children[cd];\ncategoryDataAdditionalClasses = [];\ndirtyTagID = category.id + '_' + categoryData.id;\n// check if categoryData is selected by resources\nselected = false;\ndirty = false;\nfor(aT in resourceData.assignedTags || []) {\nassignedTagAttributes = (resourceData.assignedTags[aT] || {}).attributes || {};\nif(assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){\nselected = true;\n}\n}\n// check if categoryData is selected by dirty resources\nif((dirtyTag = model.dirtyAssignedTags[dirtyTagID])){\ndirty = true;\nselected = dirtyTag.type !== 'delete'\n}\nif(selected) \tcategoryDataAdditionalClasses.push('selected');\nif(dirty) \t\tcategoryDataAdditionalClasses.push('dirty');\nlevel = categoryData.level || 0\nif(lastLevel){\nif(lastLevel > level) {\nfor(l = lastLevel; l > level; l--){\n%></div><%\n}\n} else if(lastLevel < level) {\n%><div class=\"categoryDataContainer\"><%\n}\n}\n%>\n<button class=\"categoryData <%= categoryDataAdditionalClasses.join(' ') %>\" data-category-id=\"<%- category.id %>\" data-category-data-id=\"<%- categoryData.id %>\">\n<i class=\"fi fi-tag-unselected\"></i>\n<i class=\"selected fi fi-tag-selected\"></i>\n<%= categoryData.name %><%= (showTagNumbers ? ' [' + categoryData.id + ' @ ' + ((categoryData.resources || {}).parentCategoryDataID || '-') + ']' : '') %>\n</button>\n<%\nlastLevel = level\n}\nfor(l = 1; l < lastLevel; l++){\n%></div><%\n}\n}\n}\n%>\n</section>\n</section>\n</div>"
  , __filename = "components/templates/tags/tagAssignment.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var c, cd, category, categoryData, aT, categoryAdditionalClasses, categoryDataAdditionalClasses, assignedTagAttributes, selected, dirty, showOption, dirtyTag, dirtyTagID;
var turnedOff, turnedOn, turnedOffByInheritance;
var preparedAssignedTag;
var level, lastLevel, l;
var showTagNumbers = storage.user.hasAccessTo('usage:show_lse_tag_numbers', 'literature');
var additionalClasses = [];
if(resourceData.useNormalDirtyColor){
additionalClasses.push('dirtyColorNormal');
}
if(config.isEnhanced !== false){
additionalClasses.push('isEnhanced');
} else {
additionalClasses.push('isNotEnhanced');
}

    ; __line = 16
    ; __append("\n<div class=\"")
    ; __line = 17
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n")
    ; __line = 18
    ; 
if(config.isEnhanced !== false){

    ; __line = 20
    ; __append( helpers.renderSection('enhanced') )
    ; 
}

    ; __line = 22
    ; __append("\n<section class=\"tagsOnly\">\n")
    ; __line = 24
    ; __append( helpers.renderSection('filter') )
    ; __append("\n<section class=\"content\">\n")
    ; __line = 26
    ; 
for(c in resourceData.options || []) {
category = resourceData.options[c];
categoryAdditionalClasses = [];
if(resourceData.preparedAssignedCategories[category.id]){
preparedAssignedTag = resourceData.preparedAssignedCategories[category.id];
turnedOff = preparedAssignedTag.turnedOff;
turnedOn = preparedAssignedTag.turnedOn;
turnedOffByInheritance = preparedAssignedTag.turnedOffByInheritance;
} else {
preparedAssignedTag = { noData: true };
turnedOff = false;
turnedOn = false;
turnedOffByInheritance = (resourceData.inheritedCategories || {})[category.id] === false;
}
dirty = false;
selected = !turnedOff && (!turnedOffByInheritance || turnedOn);
inherited = !turnedOff && !turnedOn;
showOption = resourceData.optionalCategories && model.turnedOffTagCategoryManagementGranted;
// check if categoryData is selected by dirty resources
if((dirtyTag = model.dirtyAssignedTags[category.id + '_null'])){
dirty = true;
selected = !selected;
}
if(selected) 	categoryAdditionalClasses.push('selected');
if(dirty) 		categoryAdditionalClasses.push('dirty');
if(showOption) 	categoryAdditionalClasses.push('showOption');
if(inherited) 	categoryAdditionalClasses.push('inherited');
if((!turnedOff && !turnedOffByInheritance) || model.turnedOffTagCategoryManagementGranted){

    ; __line = 55
    ; __append("\n<div class=\"category ")
    ; __line = 56
    ; __append(escapeFn( categoryAdditionalClasses.join(' ') ))
    ; __append("\" data-category-id=\"")
    ; __append( category.id )
    ; __append("\" data-category-data-id=\"null\">\n<i class=\"unselected fi fi-tagFamily-unselected\"></i>\n<i class=\"selected fi fi-tagFamily-selected\"></i>\n<i class=\"inherited fi fi-tagFamily-inherited\"></i>\n")
    ; __line = 60
    ; __append(escapeFn( category.name ))
    ; __append(escapeFn( (showTagNumbers ? ' [' + category.id + ']' : '') ))
    ; __append("\n</div>\n")
    ; __line = 62
    ; 
lastLevel = undefined;
for(cd in category.children || []) {
categoryData = category.children[cd];
categoryDataAdditionalClasses = [];
dirtyTagID = category.id + '_' + categoryData.id;
// check if categoryData is selected by resources
selected = false;
dirty = false;
for(aT in resourceData.assignedTags || []) {
assignedTagAttributes = (resourceData.assignedTags[aT] || {}).attributes || {};
if(assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){
selected = true;
}
}
// check if categoryData is selected by dirty resources
if((dirtyTag = model.dirtyAssignedTags[dirtyTagID])){
dirty = true;
selected = dirtyTag.type !== 'delete'
}
if(selected) 	categoryDataAdditionalClasses.push('selected');
if(dirty) 		categoryDataAdditionalClasses.push('dirty');
level = categoryData.level || 0
if(lastLevel){
if(lastLevel > level) {
for(l = lastLevel; l > level; l--){

    ; __line = 88
    ; __append("</div>")
    ; 
}
} else if(lastLevel < level) {

    ; __line = 91
    ; __append("<div class=\"categoryDataContainer\">")
    ; 
}
}

    ; __line = 94
    ; __append("\n<button class=\"categoryData ")
    ; __line = 95
    ; __append(escapeFn( categoryDataAdditionalClasses.join(' ') ))
    ; __append("\" data-category-id=\"")
    ; __append( category.id )
    ; __append("\" data-category-data-id=\"")
    ; __append( categoryData.id )
    ; __append("\">\n<i class=\"fi fi-tag-unselected\"></i>\n<i class=\"selected fi fi-tag-selected\"></i>\n")
    ; __line = 98
    ; __append(escapeFn( categoryData.name ))
    ; __append(escapeFn( (showTagNumbers ? ' [' + categoryData.id + ' @ ' + ((categoryData.resources || {}).parentCategoryDataID || '-') + ']' : '') ))
    ; __append("\n</button>\n")
    ; __line = 100
    ; 
lastLevel = level
}
for(l = 1; l < lastLevel; l++){

    ; __line = 104
    ; __append("</div>")
    ; 
}
}
}

    ; __line = 108
    ; __append("\n</section>\n</section>\n</div>")
    ; __line = 111
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/tags/tagAssignment.ejs

}